import type { Domain } from '@/config/domain/type';

export const trademarksOnlineAustralia: Domain = {
    domain: import.meta.env.VITE_TMO_AU_DOMAIN,
    website: 'http://www.trademarksonline.com.au',
    shortCode: 'tmo-au',
    markSource: 'TMOV2-AU',
    title: 'Apply for your Australian trademark',
    name: 'Trademarks Online Australia',
    description: 'Our online trademark registration platform is available 24/7 and takes just minutes. Apply for your Australian trademark by entering your trademark or logo.',
    logo: '/img/TM-Logo-White-Thin.png',
    menuItems: [
        { label: 'Home', url: '' },
        { label: 'Pricing', url: '/pricing' },
        { label: 'FAQ', url: '/trademark-questions' },
        { label: 'About', url: '/about-us' },
    ],
    footerItems: [
        { label: 'Privacy Policy', url: '/privacy-policy' },
        { label: 'Terms of Use', url: '/terms-of-use' },
        { label: 'Contact Us', url: '/contact' },
    ],
    termOfUseUrl: '/terms-of-use',
    bannerImageUrl: '',
    gtmId: 'GTM-WN9J2SB3',
};
